export const theme = {
  primary: 'hsl(49, 100%, 58%)',
  black: 'hsl(0, 0%, 0%)',
  grey: 'hsl(0, 0%, 97%)',
  white: 'hsl(0, 0%, 100%)',
}
